module.exports = __webpack_public_path__ + "assets/img/97f4094c79b9b0a3bdabd21a2c53656c.png";